import { axiosGuest } from '../axiosInstance';
export default {
  getSkillsList() {
    return axiosGuest.get('/public/skills');
  },
  getCitiesOfACountry(countryId) {
    return axiosGuest.get('/public/countries/' + countryId + '?states=yes');
  },
  getIndustyList() {
    return axiosGuest.get('/public/industries');
  },
  getNetworkList() {
    return axiosGuest.get('/public/networks');
  }
};
